import React from "react";
import { useLocation } from "react-router-dom";
import { SupersetEmbedReport } from "../components";

const DASHBOARD_ID = "2f10d15c-8981-47a0-94cb-3ff50081aa76";

export const StoreReports = () => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const breadcrumbLinks = [
    { name: "Dashboard", href: isStoreAdmin ? "/store-admin" : "/" },
    { name: "External Reports" },
    { name: "Store Reports" },
  ];

  return (
    <SupersetEmbedReport
      title="Store Reports"
      dashboardId={DASHBOARD_ID}
      breadcrumbLinks={breadcrumbLinks}
    />
  );
};
